import React from "react";
import { useMsal } from "@azure/msal-react";
import Navbar from '../components/Navbar';

const customLinks = [
  { href: "/", label: "Home" },
  { href: "/#about", label: "About Us" },
  { href: "/#services", label: "Our Service" },
  { href: "/#newsletter", label: "Contact Us" },
];

const ProtectedRoute = ({ children }) => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  if (!activeAccount) {
    // User not logged in → show a message
    return (

      <div className="flex flex-col items-center justify-center h-screen text-center">
      <Navbar links={customLinks} />
        <h1 className="text-4xl font-bold text-red-600">Access Denied</h1>
        <p className="text-lg text-gray-700 mt-4">
          You must be logged in to view this page.
        </p>
      </div>
    );
  }

  // User logged in → render the child component
  return children;
};

export default ProtectedRoute;
